module.exports = __webpack_public_path__ + "img/huawei.48c1e85c.jpg";